import httpClient from './httpClient'

export interface PlatformSettings {
  userId?: string
  timezone: string
  timezoneAbbreviation: string
  timezoneLabel: string
  portalType?: string
  modifiedAt?: string
}

export interface TimezoneOption {
  id: string
  label: string
  abbreviation: string
}

export async function getPlatformSettings(): Promise<PlatformSettings> {
  const { data } = await httpClient.get<PlatformSettings>('catalog/api/platform/settings')
  return data
}

export async function getPlatformTimezones(): Promise<TimezoneOption[]> {
  const { data } = await httpClient.get<TimezoneOption[]>('catalog/api/platform/settings/timezones')
  return data
}

export async function updatePlatformSettings(timezone: string): Promise<PlatformSettings> {
  const { data } = await httpClient.put<PlatformSettings>('catalog/api/platform/settings', {
    timezone,
    portalType: 'CLIENT',
  })
  return data
}
